import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button, DatePicker, Modal } from '../../../../common/components';
import { closeModal, openModal } from '../../../../common/components/Modal/ModalRedux';
import { actions } from '../../redux/ProductReducer';
import { get, set } from 'lodash';
import './styles.scss';

const FORM_NAME = 'activateSchemeForm';

class ActivateSchemeButton extends Component {
  componentWillUpdate(newProps) {
    const { dispatch, submitSucceeded, callback } = this.props;
    if (newProps.submitSucceeded && !submitSucceeded) {
      if (callback) {
        callback('');
      }
      dispatch(closeModal(FORM_NAME));
    }
  }

  handleSubmit(values) {
    const { dispatch, resource, onActivationComplete } = this.props;
    return Promise.resolve(
      dispatch(actions.activateFeeScheme(resource.data.id, values)),
    ).then(() => {
      onActivationComplete();
    });
  }

  handleOpen() {
    const { dispatch, reset } = this.props;
    dispatch(reset());
    dispatch(openModal(FORM_NAME));
  }

  render() {
    const { label, handleSubmit, submitting, pristine } = this.props;
    const submitButton = (
      <Button
        type="submit"
        bsStyle="primary"
        disabled={submitting || pristine}
        isLoading={submitting}
        label="Activate"
      />
    );

    return (
      <div className={'activate-scheme-btn-wrapper ' + this.props.className}>
        {!this.props.hideButton && (
          <Button
            bsStyle="primary"
            className="btn-blue"
            label={label}
            isLoading={submitting}
            rightIcon="check"
            handleClick={this.handleOpen.bind(this)}
          />
        )}
        <Modal
          name={FORM_NAME}
          title={label}
          close={true}
          handleSubmit={handleSubmit(this.handleSubmit.bind(this))}
          footer={submitButton}
        >
          <div className="form-horizontal">
            <div className="col-xs-12">
              <p>
                <strong>Please note:</strong> once the scheme has been made active it will
                no longer be available for editing.
              </p>
              <div style={{ margin: '20px 0' }}>
                <Field
                  name={'meta.date'}
                  label="Start date"
                  labelSize={3}
                  component={DatePicker}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const validate = (values) => {
  const errors = {};

  if (!get(values, 'meta.date')) {
    set(errors, 'meta.date', 'Start date is required');
  }
  return errors;
};

ActivateSchemeButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
  callback: PropTypes.func,
  label: PropTypes.string,
  schemeType: PropTypes.string,
};

const form = reduxForm({ form: FORM_NAME, validate })(ActivateSchemeButton);
export default connect()(form);
